import React, { useState } from "react";
import { LuBadgePlus } from "react-icons/lu";
import { CATEGORIES } from "../constants";
import CloseableMessage from "./CloseableMessage";

const AddNameModal = ({ isOpen, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    eng_word: "",
    syr_word: "",
    arb_word: "",
    gender: "",
    meaning: "",
    category: [],
  });
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox" && name === "category") {
      setFormData((prev) => {
        const categories = prev.category || [];
        if (checked) {
          return { ...prev, category: [...categories, value] };
        } else {
          return { ...prev, category: categories.filter((c) => c !== value) };
        }
      });
    } else if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    // Validation
    if (!formData.eng_word || formData.eng_word.trim() === "") {
      setError("Please provide the English name.");
      setIsSubmitting(false);
      return;
    }
    if (!formData.gender) {
      setError("Please select a gender.");
      setIsSubmitting(false);
      return;
    }
    if (!formData.meaning || formData.meaning.trim() === "") {
      setError("Please provide a meaning for the name.");
      setIsSubmitting(false);
      return;
    }
    try {
      const baseUrl =
        process.env.NODE_ENV === "development"
          ? "https://curser-names.vercel.app/"
          : "/";
      // Replace with your actual API endpoint and payload
      const response = await fetch(`${baseUrl}api/names/add-name`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Failed to add name");
      }
      console.log("data: ", data);
      await fetch(`${baseUrl}api/notify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, id: data.data?.id }),
      });

      setShowSuccess(true);
    } catch (err) {
      setError(err.message || "An error occurred while adding the name");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;
  const SuccessMessage = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: 250,
          position: "relative",
        }}
      >
        <button
          onClick={() => {
            setShowSuccess(false);
            onClose();
          }}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            background: "none",
            border: "none",
            fontSize: 24,
            color: "#22c55e",
            cursor: "pointer",
            fontWeight: 700,
          }}
          aria-label="Close"
        >
          &times;
        </button>
        <div style={{ fontSize: 48, color: "#22c55e", marginBottom: 16 }}>
          ✔️
        </div>
        <div
          style={{
            fontSize: 20,
            fontWeight: 600,
            color: "#065f46",
            marginBottom: 8,
          }}
        >
          Thank you!
        </div>
        <div style={{ color: "#065f46", fontSize: 15, textAlign: "center" }}>
          Your name submission was received.
          <br />
          BET KANU team will review it
        </div>
      </div>
    );
  };
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.3)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          padding: "24px 28px",
          width: "100%",
          maxWidth: 480,
          boxSizing: "border-box",
          boxShadow: "0 4px 32px rgba(0,0,0,0.12)",
          position: "relative",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        {showSuccess ? (
          <SuccessMessage />
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h2
                style={{
                  // margin: 0,
                  fontSize: 22,
                  fontWeight: 600,
                  textAlign: "left",
                }}
              >
                Add Baby Name
              </h2>
              <button
                onClick={onClose}
                style={{
                  // flex: 1,
                  // position: "absolute",
                  // top: 18,
                  // right: 18,
                  background: "none",
                  border: "none",
                  fontSize: 40,
                  cursor: "pointer",
                }}
                aria-label="Close"
              >
                &times;
              </button>
            </div>

            <CloseableMessage>
              Help us grow our collection! By sharing a name, you're helping
              families and communities discover meaningful, beautiful names.
            </CloseableMessage>
            <form
              onSubmit={handleSubmit}
              style={{ display: "flex", flexDirection: "column", gap: 18 }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <label
                  htmlFor="eng_word"
                  style={{ marginBottom: 6, fontWeight: 500 }}
                >
                  English
                </label>
                <input
                  id="eng_word"
                  name="eng_word"
                  type="text"
                  placeholder="Enter name in English"
                  value={formData.eng_word}
                  onChange={handleChange}
                  required
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "10px 12px",
                    borderRadius: 8,
                    border: "1px solid #e5e7eb",
                    background: "#f8fafc",
                    fontSize: 15,
                    outline: "none",
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <label
                  htmlFor="syr_word"
                  style={{ marginBottom: 6, fontWeight: 500 }}
                >
                  Syriac
                </label>
                <input
                  id="syr_word"
                  name="syr_word"
                  type="text"
                  placeholder="Enter name in Syriac"
                  value={formData.syr_word}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "10px 12px",
                    borderRadius: 8,
                    border: "1px solid #e5e7eb",
                    background: "#f8fafc",
                    fontSize: 15,
                    outline: "none",
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <label
                  htmlFor="arb_word"
                  style={{ marginBottom: 6, fontWeight: 500 }}
                >
                  Arabic
                </label>
                <input
                  id="arb_word"
                  name="arb_word"
                  type="text"
                  placeholder="Enter name in Arabic"
                  value={formData.arb_word}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "10px 12px",
                    borderRadius: 8,
                    border: "1px solid #e5e7eb",
                    background: "#f8fafc",
                    fontSize: 15,
                    outline: "none",
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: 8,
                }}
              >
                <label style={{ fontWeight: 500, marginBottom: 2 }}>
                  Gender
                </label>
                <div style={{ display: "flex", gap: 18 }}>
                  <label
                    style={{ display: "flex", alignItems: "center", gap: 4 }}
                  >
                    <input
                      type="radio"
                      name="gender"
                      value="male"
                      checked={formData.gender === "male"}
                      onChange={handleChange}
                    />
                    Boy
                  </label>
                  <label
                    style={{ display: "flex", alignItems: "center", gap: 4 }}
                  >
                    <input
                      type="radio"
                      name="gender"
                      value="female"
                      checked={formData.gender === "female"}
                      onChange={handleChange}
                    />
                    Girl
                  </label>
                  <label
                    style={{ display: "flex", alignItems: "center", gap: 4 }}
                  >
                    <input
                      type="radio"
                      name="gender"
                      value="neutral"
                      checked={formData.gender === "neutral"}
                      onChange={handleChange}
                    />
                    Neutral
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    width: "100%",
                    marginTop: 14,
                  }}
                >
                  <label
                    style={{
                      fontWeight: 500,
                      marginBottom: 6,
                      display: "block",
                    }}
                  >
                    Category
                  </label>
                  <div className="category-checkboxes">
                    {CATEGORIES.map((cat) => (
                      <label
                        key={cat}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                      >
                        <input
                          type="checkbox"
                          name="category"
                          value={cat}
                          checked={formData.category.includes(cat)}
                          onChange={handleChange}
                        />
                        {cat}
                      </label>
                    ))}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    width: "100%",
                    marginTop: 8,
                  }}
                >
                  <label
                    htmlFor="meaning"
                    style={{ marginBottom: 6, fontWeight: 500 }}
                  >
                    Description
                  </label>
                  <textarea
                    id="meaning"
                    name="meaning"
                    placeholder="Add meaning of the name. Any interesting information about the name is welcome."
                    value={formData.meaning}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      padding: "10px 12px",
                      borderRadius: 8,
                      border: "1px solid #e5e7eb",
                      background: "#f8fafc",
                      fontSize: 15,
                      minHeight: 60,
                      outline: "none",
                      resize: "vertical",
                    }}
                  />
                </div>
              </div>
              {error && (
                <div style={{ color: "#e11d48", marginBottom: 8 }}>{error}</div>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 12,
                  marginTop: 8,
                }}
              >
                <button
                  type="button"
                  onClick={onClose}
                  className="btn-danger-with-icon"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-primary-with-icon"
                  disabled={isSubmitting}
                >
                  <LuBadgePlus size={20} />
                  {isSubmitting ? "Adding..." : "Add"}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddNameModal;
